import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

/** Media served by the backend comes back as "/api/media/<id>"; make it absolute. */
export const mediaUrl = (u) => {
  if (!u) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getDistricts = () => api.get("/districts").then((r) => r.data);
export const getDistrict = (slug) => api.get(`/districts/${slug}`).then((r) => r.data);
export const getPackages = () => api.get("/packages").then((r) => r.data);
export const getBlogList = (params = {}) =>
  api.get("/blog", { params }).then((r) => r.data);
export const getBlog = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getBlogCategories = () => api.get("/blog-categories").then((r) => r.data);
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
